import React, { useEffect } from 'react';

import{
  Section, Container, ContactSection,
} from 'components';
import { CompanyPhone } from 'variables';
import {
  Case01, Case01Mobile, Case02, Case02Mobile, Case03, Case03Mobile,
} from 'assets';
import {
  CaseWrapper, CaseImage,
} from './style';

const Case: React.FC = _ => {
  useEffect(() => {
    const id = window.location.hash.substr(1);

    if (id) {
      const anchor = document.getElementById(id);
      if (anchor) {
        anchor.scrollIntoView();
      }
    }
  }, []);

  return (
    <div>
      <Section minHeight={250}>
        <h1>데이트팝 제휴점 신청하시고,<br/>최고의 광고 효과를 누려보세요!</h1>
        <a href={`tel:${CompanyPhone.replace(/-/g, '')}`}>{CompanyPhone}</a>
      </Section>

      <Container>
        <CaseWrapper>
          <CaseImage id="case_01" src={Case01} alt="이미지" />
          <CaseImage id="case_mobile_01" src={Case01Mobile} alt="이미지" isMobile={true} />
          <CaseImage id="case_02" src={Case02} alt="이미지" />
          <CaseImage id="case_mobile_02" src={Case02Mobile} alt="이미지" isMobile={true} />
          <CaseImage id="case_03" src={Case03} alt="이미지" />
          <CaseImage id="case_mobile_03" src={Case03Mobile} alt="이미지" isMobile={true} />
        </CaseWrapper>
      </Container>

      <ContactSection />
    </div>
  );
};

export default Case;
